module.exports = __webpack_public_path__ + "static/media/myself.f24b87a6.svg";